(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './de-de', './en-au', './en-ae', './en-ca', './en-dk', './en-fi', './en-hk', './en-in', './en-se', './en-sg', './en-uk', './en-us', './en-za', './fr-ca', './fr-fr', './it-it', './ja-jp', './ko-kr', './nl-nl', './en-no', './en-be', './pt-br', './sp-mx', './es-es', './es-ar', './zh-hans-cn', './zh-tw'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./de-de'), require('./en-au'), require('./en-ae'), require('./en-ca'), require('./en-dk'), require('./en-fi'), require('./en-hk'), require('./en-in'), require('./en-se'), require('./en-sg'), require('./en-uk'), require('./en-us'), require('./en-za'), require('./fr-ca'), require('./fr-fr'), require('./it-it'), require('./ja-jp'), require('./ko-kr'), require('./nl-nl'), require('./en-no'), require('./en-be'), require('./pt-br'), require('./sp-mx'), require('./es-es'), require('./es-ar'), require('./zh-hans-cn'), require('./zh-tw'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.deDe, global.enAu, global.enAe, global.enCa, global.enDk, global.enFi, global.enHk, global.enIn, global.enSe, global.enSg, global.enUk, global.enUs, global.enZa, global.frCa, global.frFr, global.itIt, global.jaJp, global.koKr, global.nlNl, global.enNo, global.enBe, global.ptBr, global.spMx, global.esEs, global.esAr, global.zhHansCn, global.zhTw);
    global.index = mod.exports;
  }
})(this, function (exports, _deDe, _enAu, _enAe, _enCa, _enDk, _enFi, _enHk, _enIn, _enSe, _enSg, _enUk, _enUs, _enZa, _frCa, _frFr, _itIt, _jaJp, _koKr, _nlNl, _enNo, _enBe, _ptBr, _spMx, _esEs, _esAr, _zhHansCn, _zhTw) {
  'use strict';

  // Translation files

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _deDe2 = _interopRequireDefault(_deDe);

  var _enAu2 = _interopRequireDefault(_enAu);

  var _enAe2 = _interopRequireDefault(_enAe);

  var _enCa2 = _interopRequireDefault(_enCa);

  var _enDk2 = _interopRequireDefault(_enDk);

  var _enFi2 = _interopRequireDefault(_enFi);

  var _enHk2 = _interopRequireDefault(_enHk);

  var _enIn2 = _interopRequireDefault(_enIn);

  var _enSe2 = _interopRequireDefault(_enSe);

  var _enSg2 = _interopRequireDefault(_enSg);

  var _enUk2 = _interopRequireDefault(_enUk);

  var _enUs2 = _interopRequireDefault(_enUs);

  var _enZa2 = _interopRequireDefault(_enZa);

  var _frCa2 = _interopRequireDefault(_frCa);

  var _frFr2 = _interopRequireDefault(_frFr);

  var _itIt2 = _interopRequireDefault(_itIt);

  var _jaJp2 = _interopRequireDefault(_jaJp);

  var _koKr2 = _interopRequireDefault(_koKr);

  var _nlNl2 = _interopRequireDefault(_nlNl);

  var _enNo2 = _interopRequireDefault(_enNo);

  var _enBe2 = _interopRequireDefault(_enBe);

  var _ptBr2 = _interopRequireDefault(_ptBr);

  var _spMx2 = _interopRequireDefault(_spMx);

  var _esEs2 = _interopRequireDefault(_esEs);

  var _esAr2 = _interopRequireDefault(_esAr);

  var _zhHansCn2 = _interopRequireDefault(_zhHansCn);

  var _zhTw2 = _interopRequireDefault(_zhTw);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  // ES-CO, ES-AR, ES-PE, ES-Cl
  // Are all clones of es-es concur.es
  // COM-5363

  var index = {
    'de-de': _deDe2.default,
    'en-au': _enAu2.default,
    'en-ae': _enAe2.default,
    'en-ca': _enCa2.default,
    'en-dk': _enDk2.default,
    'en-fi': _enFi2.default,
    'en-hk': _enHk2.default,
    'en-in': _enIn2.default,
    'en-se': _enSe2.default,
    'en-sg': _enSg2.default,
    'en-uk': _enUk2.default,
    'en-us': _enUs2.default,
    'en-za': _enZa2.default,
    'en-no': _enNo2.default,
    'fr-ca': _frCa2.default,
    'fr-fr': _frFr2.default,
    'it-it': _itIt2.default,
    'ja-jp': _jaJp2.default,
    'ko-kr': _koKr2.default,
    'nl-nl': _nlNl2.default,
    'en-be': _enBe2.default,
    'pt-br': _ptBr2.default,
    'sp-mx': _spMx2.default,
    'es-es': _esEs2.default,
    'es-ar': _esAr2.default,
    'zh-hans-cn': _zhHansCn2.default,
    'zh-tw': _zhTw2.default
  };

  // LATAM Sites are based on EsAr menu
  index['es-pe'] = _esAr2.default;
  index['es-pe']['domain'] = 'https://www.concur.pe';

  index['es-cl'] = _esAr2.default;
  index['es-cl']['domain'] = 'https://www.concur.cl';

  index['es-co'] = _esAr2.default;
  index['es-co']['domain'] = 'https://www.concur.co';

  exports.default = index;
});